export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1650284178711-f1c13222f793?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA8Mzl8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3b21hbiUyMHlvZ2ElMjBtb3JuaW5nJTIwc3VubGlnaHQlMjBuYXR1cmVsZW58MHx8fHwxNzkwMDc5NDY3fDA&ixlib=rb-4.1.0&q=85",
  founder: "/dr-anjali.png",
  botanical: "https://images.unsplash.com/photo-1775640730391-45f5f8329ee6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxncmVlbiUyMGxlYXZlc3xlbnwwfHx8fDE3OTExMzQ1MzB8MA&ixlib=rb-4.1.0&q=85",
  thali: "https://images.unsplash.com/photo-1742281258189-3b933879867a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxoZWFsdGh5JTIwaW5kaWFuJTIwZm9vZCUyMHRoYWxpJTIwb3JnYW5pYyUyMG1lYWx8ZW58MHx8fHwxNzkxMTM0NTI5fDA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Our Approach", id: "approach" },
  { label: "Programs", id: "programs" },
  { label: "Mini Courses", id: "mini-courses" },
  { label: "What You Get", id: "what-you-get" },
  { label: "Client Stories", id: "stories" },
  { label: "Resources", id: "resources" },
  { label: "FAQ", id: "faq" },
];

export const CREDENTIALS = [
  { title: "PhD", sub: "Research & Academic Background" },
  { title: "Certified Health Coach", sub: "Personalised Health & Lifestyle Coaching" },
  { title: "Certified Nutrigenomics Consultant", sub: "DNA-Based Personalised Nutrition & Wellness" },
  { title: "Certified Meditation Trainer", sub: "Mind-Body & Stress Regulation" },
];

export const PROBLEMS = [
  {
    icon: "Scale",
    title: "Stubborn Weight Gain",
    text: "You're trying to eat better and stay active, but managing your weight still feels difficult.",
  },
  {
    icon: "Activity",
    title: "Thyroid Concerns",
    text: "You want practical lifestyle support for energy, metabolism and healthy routines while managing thyroid health.",
  },
  {
    icon: "Flower2",
    title: "PCOS Challenges",
    text: "You want sustainable nutrition, movement and lifestyle support rather than another restrictive plan.",
  },
  {
    icon: "Droplet",
    title: "Blood Sugar Concerns",
    text: "You want to understand your blood sugar patterns and develop healthier metabolic habits.",
  },
  {
    icon: "Salad",
    title: "Gut & Digestive Issues",
    text: "Bloating, digestive discomfort and irregular routines affect how you feel every day.",
  },
  {
    icon: "Brain",
    title: "Stress & Overthinking",
    text: "Your mind stays busy, your body feels tired and recovery keeps getting pushed aside.",
  },
];

export const ECOSYSTEM_NODES = [
  "Nutrition",
  "Movement",
  "Metabolism",
  "Sleep",
  "Stress",
  "Digestion",
  "Mind",
  "Habits",
  "Lifestyle",
  "Environment",
  "DNA-Based Plan",
];

const SHARED_RECEIVE = [
  "Weekly 1:1 personalised coaching sessions with Dr. Anjali",
  "Personalised nutrition plan built around your real life",
  "Personalised workout & movement plan",
  "Travel & festival guidance",
  "Access to 150+ healthy recipes",
  "Habit, nutrition, movement & progress trackers",
  "Ongoing personalised accountability",
  "Lifestyle integration around your responsibilities",
];

const HOW_COACHING_WORKS = [
  "Begin with your free Discovery Call so Dr. Anjali understands your concerns, lifestyle and goals.",
  "Receive your personalised pathway with nutrition, movement and habit systems designed around you.",
  "Meet weekly for 1:1 coaching to review progress, solve challenges and adjust your plan.",
  "Build sustainable habits with trackers, accountability and real-life guidance that lasts beyond coaching.",
];

export const PROGRAMS = [
  {
    slug: "mother-fit",
    name: "M.O.T.H.E.R. Fit™",
    subtitle: "Weight Management for Busy Mothers",
    tagline: "Lose weight without making your life revolve around dieting.",
    description:
      "A personalised health coaching pathway for busy mothers who want to work toward sustainable weight management while balancing family, work and everyday responsibilities.",
    image:
      "https://images.unsplash.com/photo-1756367141220-570ab35ec2f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3b21hbiUyMHlvZ2ElMjB3ZWxsbmVzcyUyMG1pbmRmdWxuZXNzJTIwbmF0dXJhbCUyMGxpZ2h0fGVufDB8fHx8MTc5MTEzNDUyOXww&ixlib=rb-4.1.0&q=85",
    accent: "#C6A052",
    whoFor: [
      "Mothers balancing family, work and their own health",
      "Women tired of restrictive diets that never last",
      "Women who want sustainable weight management, not quick fixes",
      "Anyone who struggles to stay consistent with healthy routines",
    ],
    concerns: ["Weight management", "Low energy", "Inconsistent routines", "Time scarcity"],
    focus: ["Weight management", "Busy lifestyle", "Family responsibilities", "Nutrition", "Movement", "Self-care", "Consistency"],
    transformation: [
      "More clarity around food without guilt",
      "Realistic routines that survive busy weeks",
      "Greater consistency and self-trust",
      "Renewed energy and confidence",
    ],
    receive: SHARED_RECEIVE,
    howItWorks: HOW_COACHING_WORKS,
    faq: [
      {
        q: "I have no time for myself. Will this still work for me?",
        a: "Yes. The entire pathway is designed around a mother's real schedule. Your plan fits your life — your life doesn't have to fit the plan.",
      },
      {
        q: "Will I have to cook separate meals for myself?",
        a: "No. Your nutrition guidance is built around family-friendly Indian meals, with practical adjustments rather than separate cooking.",
      },
      {
        q: "Is this another diet plan?",
        a: "No. It is a personalised health system covering nutrition, movement, sleep, stress and habits — designed to be sustainable beyond the coaching period.",
      },
    ],
    disclaimer:
      "Aarogyam Bharat provides health and wellness coaching. This pathway does not replace medical diagnosis, treatment or advice from qualified healthcare professionals.",
  },
  {
    slug: "thyroid-balance",
    name: "T.H.Y.R.O.I.D. Balance™",
    subtitle: "Thyroid Wellness & Metabolic Support",
    tagline: "Support your energy, metabolism and healthy lifestyle while managing thyroid health.",
    description:
      "A personalised lifestyle pathway focused on nutrition, movement, stress, sleep and sustainable health habits alongside appropriate medical care.",
    image:
      "https://images.unsplash.com/photo-1663691449187-f948a747ad91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3b21hbiUyMHlvZ2ElMjB3ZWxsbmVzcyUyMG1pbmRmdWxuZXNzJTIwbmF0dXJhbCUyMGxpZ2h0fGVufDB8fHx8MTc5MTEzNDUyOXww&ixlib=rb-4.1.0&q=85",
    accent: "#90A955",
    whoFor: [
      "Women managing thyroid health who want lifestyle support",
      "Those dealing with low energy and sluggish routines",
      "Women who want to build healthier metabolic habits",
      "Anyone seeking structure alongside their medical care",
    ],
    concerns: ["Thyroid wellness", "Low energy", "Metabolic habits", "Weight fluctuations"],
    focus: ["Thyroid-related lifestyle support", "Energy", "Metabolic habits", "Nutrition", "Stress", "Sleep", "Movement"],
    transformation: [
      "Better daily energy rhythms",
      "Healthier metabolic routines",
      "Calmer stress and sleep patterns",
      "A lifestyle system that supports your care plan",
    ],
    receive: SHARED_RECEIVE,
    howItWorks: HOW_COACHING_WORKS,
    faq: [
      {
        q: "Does this replace my thyroid medication?",
        a: "No. This pathway supports your lifestyle alongside your doctor's care. Never change medication without your treating physician.",
      },
      {
        q: "What does lifestyle support for thyroid health mean?",
        a: "It means working on nutrition, movement, sleep, stress and daily habits — the foundations that influence how you feel every day.",
      },
      {
        q: "Is the plan personalised to my reports?",
        a: "Your coaching is personalised to your lifestyle, goals and concerns. Medical interpretation of reports remains with your healthcare provider.",
      },
    ],
    disclaimer:
      "This pathway supports lifestyle alongside appropriate medical care. It does not replace medical diagnosis, treatment or medication prescribed by your doctor.",
  },
  {
    slug: "pcos-harmony",
    name: "P.C.O.S. Harmony™",
    subtitle: "PCOS Metabolic & Hormonal Wellness",
    tagline: "Build healthier metabolic and lifestyle foundations for better PCOS management.",
    description:
      "A personalised coaching pathway supporting nutrition, movement, stress regulation, sleep and sustainable lifestyle habits for women navigating PCOS.",
    image:
      "https://images.unsplash.com/photo-1775640730391-45f5f8329ee6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxuYXR1cmUlMjBmb3Jlc3QlMjBsZWF2ZXN8ZW58MHx8fDE3OTExMzQ1MzB8MA&ixlib=rb-4.1.0&q=85",
    accent: "#4F772D",
    whoFor: [
      "Women navigating PCOS who want sustainable lifestyle support",
      "Those tired of blaming themselves for inconsistency",
      "Women who want to understand their metabolic health",
      "Anyone seeking structure without restriction or guilt",
    ],
    concerns: ["PCOS wellness", "Metabolic health", "Weight management", "Irregular routines"],
    focus: ["PCOS lifestyle support", "Metabolic health", "Nutrition", "Movement", "Stress", "Sleep", "Healthy routines"],
    transformation: [
      "Healthier metabolic habits you understand",
      "More stable energy and routines",
      "Food awareness without fear",
      "Confidence in managing your lifestyle",
    ],
    receive: SHARED_RECEIVE,
    howItWorks: HOW_COACHING_WORKS,
    faq: [
      {
        q: "Can coaching cure PCOS?",
        a: "No. Coaching does not cure or treat PCOS. It supports you in building lifestyle foundations that work alongside your medical care.",
      },
      {
        q: "Will I need to follow a very restrictive diet?",
        a: "No. The approach focuses on sustainable nutrition and habits — not restriction, fear or extreme rules.",
      },
      {
        q: "I keep starting and stopping. How is this different?",
        a: "Weekly 1:1 accountability and a system built around your real life make consistency finally achievable.",
      },
    ],
    disclaimer:
      "This pathway provides lifestyle and wellness support. It does not claim to cure, reverse or treat PCOS and does not replace medical care.",
  },
  {
    slug: "sugar-reset",
    name: "S.U.G.A.R. Reset™",
    subtitle: "Blood Sugar & Metabolic Health",
    tagline: "Understand your blood sugar, improve your daily metabolic habits and take control of your health.",
    description:
      "A personalised lifestyle pathway focused on nutrition, meal patterns, movement, sleep, stress and healthier metabolic habits.",
    image:
      "https://images.unsplash.com/photo-1742281257687-092746ad6021?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwaW5kaWFuJTIwZm9vZCUyMHRoYWxpJTIwb3JnYW5pYyUyMG1lYWx8ZW58MHx8fHwxNzkxMTM0NTI5fDA&ixlib=rb-4.1.0&q=85",
    accent: "#D4A373",
    whoFor: [
      "Those who want to understand their blood sugar patterns",
      "People eating 'healthy' but still seeing fluctuations",
      "Anyone wanting better meal structure and timing",
      "Those building long-term metabolic health habits",
    ],
    concerns: ["Blood-sugar awareness", "Metabolic health", "Meal structure", "Energy crashes"],
    focus: ["Blood-sugar awareness", "Meal structure", "Nutrition", "Movement", "Metabolic habits", "Sleep", "Stress"],
    transformation: [
      "Understanding of how meals, movement, sleep and stress connect",
      "Better daily meal structure and timing",
      "Steadier energy through the day",
      "A system you can understand and follow",
    ],
    receive: SHARED_RECEIVE,
    howItWorks: HOW_COACHING_WORKS,
    faq: [
      {
        q: "Does this replace diabetes medication or treatment?",
        a: "Absolutely not. This pathway supports lifestyle habits alongside your medical treatment. Never adjust medication without your doctor.",
      },
      {
        q: "Will I have to give up everything I enjoy eating?",
        a: "No. The focus is on meal structure, timing, balance and habits — not eliminating everything you love.",
      },
      {
        q: "What will I actually learn?",
        a: "How nutrition, movement, sleep and stress influence your daily metabolic health — and how to build a system around them.",
      },
    ],
    disclaimer:
      "This pathway does not replace diabetes medication, medical treatment or advice from qualified healthcare professionals. It supports lifestyle management alongside your medical care.",
  },
  {
    slug: "slim-reset",
    name: "S.L.I.M. RESET™",
    subtitle: "Sustainable Weight Management & Metabolic Wellness",
    tagline: "Lose weight by changing the system, not by starving yourself.",
    description:
      "Personalised weight-management coaching built around nutrition, movement, sleep, stress, habits and sustainable lifestyle change.",
    image:
      "https://images.unsplash.com/photo-1785340471479-0f02c1968978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxuYXR1cmUlMjBmb3Jlc3QlMjBsZWF2ZXN8ZW58MHx8fDE3OTExMzQ1MzB8MA&ixlib=rb-4.1.0&q=85",
    accent: "#E09F67",
    whoFor: [
      "Those dealing with digestive discomfort and stress",
      "Overthinkers whose minds stay busy and bodies feel tired",
      "Anyone wanting mindful eating and calmer routines",
      "Those curious about the mind–body–gut connection",
    ],
    concerns: ["Digestive wellness", "Stress & overthinking", "Mindful eating", "Recovery & rest"],
    focus: ["Stress", "Mind-body regulation", "Digestion", "Gut-supportive lifestyle habits", "Mindful eating", "Sleep", "Recovery"],
    transformation: [
      "A calmer relationship with food and eating",
      "Greater awareness of stress and its effects",
      "Gut-supportive daily routines",
      "Better rest, recovery and rhythm",
    ],
    receive: SHARED_RECEIVE,
    howItWorks: HOW_COACHING_WORKS,
    faq: [
      {
        q: "Is meditation a part of this pathway?",
        a: "Yes. As a Meditation Trainer, Dr. Anjali integrates practical mind-body regulation and mindfulness guidance into your routine.",
      },
      {
        q: "Is this a medical gut treatment?",
        a: "No. This is lifestyle and wellness coaching exploring the connection between stress, habits and digestion — not medical treatment.",
      },
      {
        q: "I'm always stressed and busy. Will this feel doable?",
        a: "Yes. Everything is designed to integrate gently into real life — small, sustainable shifts rather than overwhelming routines.",
      },
    ],
    disclaimer:
      "This pathway provides holistic lifestyle and wellness coaching. It does not replace medical or psychological diagnosis, treatment or therapy.",
  },
  {
    slug: "tatva-balance",
    name: "TATVA Balance™",
    subtitle: "Personalised Meditation for Mind–Body Balance",
    tagline: "Align the five elements within you. Restore calm, clarity and inner balance.",
    description:
      "A personalised meditation and mind-body pathway inspired by the Pancha Mahabhutas — the five great elements — helping you build stillness, awareness and emotional balance through guided practice and daily rituals.",
    image:
      "https://images.unsplash.com/photo-1769238507274-59e0db6c6bbe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA5NTN8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3b21hbiUyMG1lZGl0YXRpbmclMjBzZXJlbmUlMjBuYXR1cmUlMjBtaW5kZnVsbmVzc3xlbnwwfHx8fDE3OTEyMTM2Mzh8MA&ixlib=rb-4.1.0&q=85",
    accent: "#ECF39E",
    whoFor: [
      "Those seeking calm amid stress, overthinking and busy routines",
      "Anyone curious about meditation but unsure where to begin",
      "Women wanting deeper mind-body awareness and emotional balance",
      "Those who want a personalised, guided practice — not a generic app",
    ],
    concerns: ["Stress & overthinking", "Restlessness", "Emotional imbalance", "Lack of stillness"],
    focus: [
      "Prithvi (Earth) — grounding & stability",
      "Jal (Water) — emotional flow & adaptability",
      "Agni (Fire) — transformation & vitality",
      "Vayu (Air) — breath, movement & mental activity",
      "Akash (Space) — openness, awareness & stillness",
      "Personalised meditation practice",
      "Daily mind-body rituals",
    ],
    transformation: [
      "A calmer, steadier mind",
      "A personal meditation practice that fits your life",
      "Greater emotional awareness and balance",
      "Daily rituals of stillness and grounding",
    ],
    receive: [
      "Weekly 1:1 personalised guidance with Dr. Anjali",
      "A personalised meditation practice designed around your mind, lifestyle and experience level",
      "Five-elements (Tatva) based mind-body balancing framework",
      "Breathwork and grounding practices",
      "Guided practices for stress and emotional regulation",
      "Daily ritual & habit design",
      "Practice, mood and consistency trackers",
      "Ongoing personalised accountability",
    ],
    howItWorks: HOW_COACHING_WORKS,
    faq: [
      {
        q: "I've never meditated before. Is this for me?",
        a: "Yes. Your practice is designed around where you are today — even five calm minutes a day is a meaningful beginning.",
      },
      {
        q: "What does 'five elements' mean in practice?",
        a: "The Pancha Mahabhutas — Prithvi (Earth), Jal (Water), Agni (Fire), Vayu (Air) and Akash (Space) — offer a gentle framework for understanding your mind-body patterns and building practices that restore balance.",
      },
      {
        q: "Is this a medical or psychological treatment?",
        a: "No. This is personalised meditation and mind-body wellness guidance. It does not replace medical or mental-health care.",
      },
    ],
    disclaimer:
      "This pathway offers personalised meditation and mind-body wellness guidance. It does not replace medical, psychological or psychiatric diagnosis, treatment or care.",
  },
];

export const BENEFITS = [
  {
    icon: "UserCheck",
    title: "Weekly 1:1 Personalised Coaching",
    text: "Regular one-to-one sessions with Dr. Anjali to understand your progress, challenges and next steps.",
  },
  {
    icon: "UtensilsCrossed",
    title: "Personalised Nutrition Plan",
    text: "A practical nutrition strategy designed around your lifestyle, food preferences, schedule, health goals and real-life responsibilities — not a rigid generic meal chart.",
  },
  {
    icon: "Dumbbell",
    title: "Personalised Workout / Movement Plan",
    text: "Movement recommendations designed around your goals, lifestyle and current capacity.",
  },
  {
    icon: "Plane",
    title: "Travel & Festival Guidance",
    text: "Practical strategies for travel, festivals, eating out, social occasions and family functions — because real life is part of the plan.",
  },
  {
    icon: "BookOpen",
    title: "150+ Healthy Recipes",
    text: "A practical recipe resource designed to make healthy eating easier and more enjoyable.",
  },
  {
    icon: "ClipboardList",
    title: "Trackers",
    text: "Habit tracking, nutrition tracking, movement tracking, progress tracking and lifestyle consistency — all in one system.",
  },
  {
    icon: "HandHeart",
    title: "Personalised Accountability",
    text: "Ongoing guidance to help you stay consistent and make adjustments when real life gets difficult.",
  },
  {
    icon: "Sprout",
    title: "Lifestyle Integration",
    text: "Build healthier routines that can work alongside your existing responsibilities.",
  },
];

export const WHY_DIFFERENT = [
  { icon: "User", title: "Personalised", text: "Your plan is designed around your life." },
  { icon: "Sprout", title: "Root-Cause Focused", text: "We look beyond isolated symptoms and explore lifestyle patterns." },
  { icon: "CheckCircle2", title: "Practical", text: "The approach must work in your actual day-to-day life." },
  { icon: "Layers", title: "Holistic", text: "Nutrition, movement, sleep, stress and habits are considered together." },
  { icon: "Users", title: "One-to-One", text: "You receive direct personalised coaching." },
  { icon: "Infinity", title: "Sustainable", text: "The goal is to build habits you can continue beyond the coaching period." },
];

export const JOURNEY_STEPS = [
  {
    num: "01",
    icon: "PencilLine",
    title: "Tell Us About You",
    text: "Complete a short form with your basic information and health concern.",
  },
  {
    num: "02",
    icon: "MessageCircle",
    title: "Continue to WhatsApp",
    text: "After submitting the form, continue to WhatsApp for the next step.",
  },
  {
    num: "03",
    icon: "Phone",
    title: "1:1 Discovery Conversation",
    text: "Dr. Anjali understands your current concerns, lifestyle, goals and challenges.",
  },
  {
    num: "04",
    icon: "Compass",
    title: "Your Recommended Pathway",
    text: "Dr. Anjali recommends the Aarogyam Bharat pathway that best fits your needs.",
  },
];

export const BEFORE_AFTER = {
  before: ["Confused", "Inconsistent", "Overwhelmed", "Restrictive dieting", "Poor routine", "Low confidence"],
  after: ["More clarity", "Better routines", "Greater consistency", "Better food awareness", "More confidence", "Sustainable habits"],
};

export const TESTIMONIALS = [
  {
    name: "Sunita",
    age: 34,
    role: "Busy Mother",
    concern: "Weight Management",
    quote:
      "For the first time, I didn't feel like I was following another strict diet. Dr. Anjali helped me understand how to make healthier choices without completely changing my lifestyle. The personalised guidance and weekly accountability made a huge difference.",
    result: "I feel more confident and consistent now.",
  },
  {
    name: "Swati",
    age: 38,
    role: "Working Professional",
    concern: "Thyroid / Low Energy",
    quote:
      "I finally understood that my health needed more than just a diet chart. What I appreciated most was that she looked at my complete lifestyle — food, sleep, stress, movement and daily routine. Everything felt practical and manageable rather than overwhelming.",
    result: "A practical system instead of overwhelm.",
  },
  {
    name: "Divya",
    age: 29,
    role: "Working Woman",
    concern: "PCOS",
    quote:
      "I stopped blaming myself for not being consistent. The biggest change for me was learning how to build habits around my actual lifestyle. The guidance was personalised, and I never felt judged.",
    result: "I now understand my body and my routine much better.",
  },
  {
    name: "Aanchal",
    age: 46,
    role: "Homemaker",
    concern: "Blood Sugar / Metabolic Health",
    quote:
      "I was eating 'healthy' but still didn't understand why my sugar levels were fluctuating. Dr. Anjali helped me look beyond simply removing sugar — meal structure, timing, movement, sleep and stress all matter.",
    result: "I finally have a system I can understand and follow.",
  },
  {
    name: "Preeti",
    age: 32,
    role: "Working Professional",
    concern: "Gut + Stress",
    quote:
      "My biggest transformation was not just what I ate — it was how I started living. The mind-body approach helped me slow down and become more aware of my eating, stress and daily habits.",
    result: "Meditation and lifestyle guidance became part of my routine.",
  },
  {
    name: "Samriddhi",
    age: 37,
    role: "Working Woman",
    concern: "Overall Experience",
    quote:
      "I didn't need another complicated health plan. I needed someone to help me understand what actually works for me. She listens, understands your lifestyle and then guides you accordingly.",
    result: "I'm building a healthier lifestyle, not temporarily following a programme.",
  },
];

export const RESOURCE_CATEGORIES = [
  {
    icon: "UtensilsCrossed",
    title: "Nutrition",
    text: "Practical nutrition education for real Indian kitchens and real schedules.",
  },
  {
    icon: "Activity",
    title: "Metabolic Health",
    text: "Understand energy, blood sugar, metabolism and the habits that shape them.",
  },
  {
    icon: "Brain",
    title: "Mind-Body Wellness",
    text: "Meditation, stress regulation and the mind-body connection, made practical.",
  },
  {
    icon: "Sprout",
    title: "Healthy Habits",
    text: "Build routines that actually stick — without perfection or guilt.",
  },
];

export const RECIPE_CATEGORIES = [
  "Breakfast",
  "Lunch",
  "Dinner",
  "Snacks",
  "Quick Meals",
  "High-Protein Options",
  "Indian Meals",
  "Family-Friendly Meals",
];

export const FAQS = [
  {
    q: "Do I need to know which program I need before booking?",
    a: "No. That's exactly what the Discovery Call is for. We'll understand your needs and help identify the most appropriate pathway.",
  },
  {
    q: "Are the programs personalised?",
    a: "Yes. Although the coaching structure is similar across pathways, recommendations are personalised according to your goals, lifestyle, preferences and concerns.",
  },
  {
    q: "Will I receive a diet chart?",
    a: "You'll receive personalised nutrition guidance designed around your lifestyle rather than a generic one-size-fits-all diet chart.",
  },
  {
    q: "Do you provide exercise guidance?",
    a: "Yes. Movement and workout recommendations are personalised according to your goals, lifestyle and circumstances.",
  },
  {
    q: "What about travel and festivals?",
    a: "Your coaching includes practical guidance for handling travel, festivals, social occasions and other real-life situations.",
  },
  {
    q: "Do you provide medical treatment?",
    a: "No. Aarogyam Bharat provides health and wellness coaching. Coaching does not replace medical diagnosis, treatment or advice from qualified healthcare professionals.",
  },
  {
    q: "How do I know which framework is right for me?",
    a: "You don't need to decide alone. Your free Discovery Call is designed to understand your situation and identify the most suitable pathway.",
  },
  {
    q: "Do you display program prices?",
    a: "Program investment is discussed after understanding your needs and identifying the appropriate coaching pathway.",
  },
];

export const MINI_COURSES = [
  {
    slug: "metabolic-reset",
    name: "7-Day Metabolic Reset™",
    category: "7-Day Mini Course",
    duration: "7 Days",
    tagline: "Reset your daily habits. Reconnect with your metabolism.",
    description:
      "A practical 7-day wellness reset focused on balanced nutrition, meal habits, movement, hydration, sleep and everyday metabolic health.",
    explore: ["7 days of guided learning", "Nutrition, movement & hydration guidance", "Simple daily tracking"],
    whoFor: [
      "Those who want a structured fresh start for their daily habits",
      "Anyone curious about everyday metabolic health",
      "Busy women who prefer small, guided daily steps",
    ],
    learn: [
      "How meal habits, movement, hydration and sleep shape everyday metabolic health",
      "Simple balanced-nutrition practices for real Indian meals",
      "How to build and track one healthy habit a day",
    ],
    included: [
      "7 days of guided learning",
      "Daily health habit",
      "Nutrition guidance",
      "Movement suggestions",
      "Hydration guidance",
      "Sleep & recovery practices",
      "Simple daily tracking",
    ],
    howItWorks: [
      "Each day focuses on one simple theme with short, practical guidance.",
      "You practise one daily habit and track it in a few seconds.",
      "A gentle reflection closes each day so the habit actually sticks.",
    ],
    cta: "explore",
    image:
      "https://images.unsplash.com/photo-1588644525273-f37b60d78512?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwSW5kaWFuJTIwdGhhbGklMjBmb29kfGVufDB8fHx8MTc5MTI2OTY3MHww&ixlib=rb-4.1.0&q=85",
    accent: "#C6A052",
    disclaimer:
      "This is a wellness education mini course. It does not diagnose, treat, cure or prevent any disease and does not replace medical advice.",
  },
  {
    slug: "gut-reset",
    name: "5-Day Gut Reset™",
    category: "5-Day Mini Course",
    duration: "5 Days",
    tagline: "Simple habits for a happier digestive routine.",
    description:
      "A gentle 5-day lifestyle reset focused on mindful eating, nourishing food choices, hydration, daily movement and habits that support digestive wellbeing.",
    explore: ["5 days of guided practices", "Gut-friendly food & mindful eating", "Daily reflection and tracking"],
    whoFor: [
      "Those who want a gentler, more mindful relationship with food",
      "Anyone looking to support everyday digestive wellbeing",
      "Busy people who want simple, guided daily practices",
    ],
    learn: [
      "Mindful eating practices you can use at every meal",
      "Gut-friendly food choices for everyday Indian kitchens",
      "How hydration and movement support digestive wellbeing",
    ],
    included: [
      "5 days of guided practices",
      "Gut-friendly food guidance",
      "Mindful eating practices",
      "Hydration",
      "Movement",
      "Daily reflection",
      "Simple tracking",
    ],
    howItWorks: [
      "Each day introduces one gentle practice with clear guidance.",
      "You apply it to your real meals and routine — no extremes.",
      "Daily reflection helps you notice what works for your body.",
    ],
    cta: "explore",
    image:
      "https://images.unsplash.com/photo-1572357176061-7c96fd2af22f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMGdyZWVuJTIwdmVnZXRhYmxlcyUyMG1pbmRmdWwlMjBmb29kJTIwcHJlcGFyYXRpb258ZW58MHx8fHwxNzkxMjY5NjcwfDA&ixlib=rb-4.1.0&q=85",
    accent: "#90A955",
    disclaimer:
      "This mini course supports everyday digestive wellbeing through lifestyle habits. It does not cure, heal or treat any digestive disease and does not replace medical care.",
  },
  {
    slug: "detox-reset",
    name: "5-Day Detox Reset™",
    category: "5-Day Mini Course",
    duration: "5 Days",
    tagline: "Pause. Simplify. Nourish. Reset.",
    description:
      "A gentle 5-day nutrition and lifestyle reset designed to help you step away from unhealthy routines and reconnect with nourishing everyday habits.",
    explore: ["5 days of guided habits", "Nourishing food & hydration focus", "Mindful eating and daily reflection"],
    whoFor: [
      "Those wanting a gentle lifestyle refresh after a busy or indulgent phase",
      "Anyone looking to simplify and nourish their daily routine",
      "People who prefer small steps over extreme cleanses",
    ],
    learn: [
      "How to simplify your plate with nourishing everyday foods",
      "Hydration and mindful-eating habits that feel easy",
      "How movement and sleep support a refreshed routine",
    ],
    included: [
      "5 days of guided habits",
      "Nourishing food guidance",
      "Hydration",
      "Mindful eating",
      "Movement",
      "Sleep support",
      "Daily reflection",
    ],
    howItWorks: [
      "Each day offers one nourishing habit to focus on.",
      "No fasting, no extremes — just simpler, kinder choices.",
      "Daily reflection keeps the reset gentle and sustainable.",
    ],
    cta: "explore",
    image:
      "https://images.pexels.com/photos/22707498/pexels-photo-22707498.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    accent: "#4F772D",
    disclaimer:
      "This is a wellness and lifestyle reset. It does not remove toxins from the body, cleanse organs, cure disease or medically detoxify the body, and it does not replace medical advice.",
  },
  {
    slug: "sleep-restore",
    name: "Sleep Restore™",
    category: "Sleep Wellness Mini Course",
    duration: "Guided Mini Course",
    tagline: "Build an evening routine your body can look forward to.",
    description:
      "A practical programme focused on creating healthier sleep habits, improving your evening routine and creating the conditions for better rest.",
    explore: ["Evening wind-down routine design", "Relaxation & breath awareness", "Simple sleep tracking"],
    whoFor: [
      "Those whose evenings feel rushed, wired or screen-heavy",
      "Anyone wanting a calmer, more consistent sleep routine",
      "Busy women whose recovery keeps getting pushed aside",
    ],
    learn: [
      "How to design an evening wind-down routine that fits your life",
      "Screen, light and environment awareness for better rest",
      "Relaxation, breath and meditation practices for the evening",
    ],
    included: [
      "Sleep routine guidance",
      "Evening wind-down practices",
      "Screen & environment awareness",
      "Relaxation practices",
      "Breath awareness",
      "Meditation",
      "Sleep tracking",
    ],
    howItWorks: [
      "Learn one element of a restful evening at a time.",
      "Build your personal wind-down routine step by step.",
      "Track your sleep habits and notice what helps you rest.",
    ],
    cta: "explore",
    image:
      "https://images.unsplash.com/photo-1552858725-a19e7fcd3ac4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjb3p5JTIwYmVkcm9vbSUyMG5pZ2h0JTIwbGFtcCUyMGhlcmJhbCUyMHRlYSUyMHJlc3R8ZW58MHx8fHwxNzkxMjY5NjcwfDA&ixlib=rb-4.1.0&q=85",
    accent: "#D4A373",
    disclaimer:
      "This mini course supports healthier sleep habits and routines. It does not treat or cure insomnia or any sleep disorder and does not replace medical care.",
  },
  {
    slug: "stress-reset",
    name: "5-Day Stress Reset™",
    category: "5-Day Mind–Body Mini Course",
    duration: "5 Days",
    tagline: "Pause the noise. Create space to breathe.",
    description:
      "A practical 5-day introduction to mindfulness, breathing, meditation and simple stress-management habits that can fit into everyday life.",
    explore: ["Daily guided practice", "Breathing, meditation & mindfulness", "One simple daily habit"],
    whoFor: [
      "Those whose minds stay busy and whose bodies feel tired",
      "Anyone curious about meditation but unsure where to begin",
      "Busy women who need calm practices that fit real life",
    ],
    learn: [
      "Simple breathing exercises you can use anywhere",
      "A beginner-friendly meditation and mindfulness practice",
      "How small daily pauses can soften a stressful day",
    ],
    included: [
      "Daily guided practice",
      "Breathing exercises",
      "Meditation",
      "Mindfulness",
      "Reflection",
      "Relaxation practices",
      "Simple daily habit",
    ],
    howItWorks: [
      "Each day offers one short guided mind-body practice.",
      "Practices take minutes, not hours — designed for real schedules.",
      "Reflection helps you notice what brings you calm.",
    ],
    cta: "explore",
    image:
      "https://images.unsplash.com/photo-1600618528240-fb9fc964b853?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxtZWRpdGF0aW9uJTIwc2VyZW5lJTIwYnJlYXRoaW5nJTIwc29mdCUyMG5hdHVyYWwlMjBsaWdodHxlbnwwfHx8fDE3OTEyNjk2NzB8MA&ixlib=rb-4.1.0&q=85",
    accent: "#E09F67",
    disclaimer:
      "This mini course offers general mindfulness and relaxation education. It does not treat anxiety, depression or any other mental-health condition and does not replace professional care.",
  },
  {
    slug: "habits-challenge",
    name: "21-Day Healthy Habits Challenge™",
    category: "21-Day Challenge",
    duration: "21 Days",
    tagline: "One small healthy habit every day.",
    description:
      "A 21-day guided challenge designed to help you build sustainable health habits through simple daily actions, education, reflection and accountability.",
    explore: ["21 daily habits, one small step at a time", "Short education, meal ideas & recipes", "Habit tracking & accountability"],
    whoFor: [
      "Those who start strong but struggle to stay consistent",
      "Anyone who wants structure, momentum and accountability",
      "People ready to build habits that outlast the challenge",
    ],
    learn: [
      "How to build habits through small daily actions",
      "Practical nutrition, movement and mindfulness basics",
      "How reflection and accountability keep you consistent",
    ],
    included: [
      "21 daily habits",
      "Short educational guidance",
      "Healthy meal ideas",
      "Simple recipes",
      "Mindfulness practices",
      "Weekly reflection",
      "Habit tracking",
      "Accountability",
    ],
    howItWorks: [
      "Each day brings one small, doable healthy habit.",
      "Weekly reflections help you review and adjust.",
      "Gentle accountability keeps your momentum for all 21 days.",
    ],
    cta: "join",
    image:
      "https://images.unsplash.com/photo-1477332552946-cfb384aeaf1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHx3b21hbiUyMG1vcm5pbmclMjB3YWxrJTIwbmF0dXJlJTIwaGVhbHRoeSUyMGxpZmVzdHlsZXxlbnwwfHx8fDE3OTEyNjk2NzB8MA&ixlib=rb-4.1.0&q=85",
    accent: "#ECF39E",
    disclaimer:
      "This challenge is a wellness education programme. It does not guarantee weight loss or any medical outcome, and it does not replace medical advice or treatment.",
  },
];

export const HEALTH_CONCERNS = [
  "Weight Management",
  "Thyroid",
  "PCOS",
  "Blood Sugar / Metabolic Health",
  "Gut / Digestive Health",
  "Stress / Overthinking",
  "Low Energy",
  "General Health & Lifestyle",
  "Other",
];
